import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ActionAdminPageHeader, ActionAdminTable } from '@/components/pages/ActionAdmin'
import routes from '@/constants/routes'
import useQueryPage from '@/hooks/useQueryPage'
import { useActionAdmin } from '@/pages/ActionAdmin/ActionAdmin.hooks'

const ActionAdmin = () => {
  const currentPage = useQueryPage()
  const navigate = useNavigate()

  const { page, pageSize, setPage, actionAdminResponse, getAction, loading } = useActionAdmin()
  const dataSource = actionAdminResponse?.items ?? []
  const totalItems = actionAdminResponse?.meta.totalItems || 0

  const handleChangePage = (config: TablePaginationConfig) => {
    setPage(config.current ?? page)
    navigate({
      pathname: routes.actionAdmin.path,
      search: `?page=${config.current ?? page}`,
    })
  }

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage)
    }
  }, [currentPage, setPage])

  useEffect(() => {
    getAction()
  }, [getAction])

  return (
    <>
      <ActionAdminPageHeader />
      <ActionAdminTable {...{ dataSource, loading, page, totalItems, pageSize }} onChange={handleChangePage} />
    </>
  )
}

ActionAdmin.displayName = 'ActionAdmin'
export default ActionAdmin
